import React from 'react';
import { useParams } from 'react-router-dom';

import GravityJobCandidates from 'modules/ATS/containers/GravityJobCandidates';
import PageNavTitle from 'modules/Common/components/PageNavTitle';
import { TabsTitleEnum } from 'modules/Common/types';
import { Routes } from 'types';

import { Styled } from './ATSGravityJobPage.styled';

const ATSGravityJobPage = () => {
	const { jobId = '' } = useParams();

	return (
		<>
			<Styled.Head>
				<PageNavTitle
					title={'Back to Gravity History'}
					navigationLink={`${Routes.ATS}${Routes.Jobs}`}
					state={{ activeTab: TabsTitleEnum.GravityHistoryTab }}
				/>
			</Styled.Head>
			<Styled.Content>
				<GravityJobCandidates jobId={jobId} />
			</Styled.Content>
		</>
	);
};

export default ATSGravityJobPage;
